export default __webpack_public_path__ + "static/media/exsample.c1f37243.png";